<template>
    <div class="table-results">
        <div class="table-results__header">{{ renderHeaderTitle() }}</div>
        <div class="table-results__content">
            <div v-if="isMultiLotto || $store.state.stepCart === 4 || $store.state.stepCart === 3" class="table-results__content__date">
                <DatePicker />
                <b>{{ formatDate(this.date) }}</b>
            </div>
            <div v-else class="table-results__content__date">
                <v-select v-model="selectedDatePariLotto" :items="dataSelectPariLotto" :label="getTranslatedText('select date')"></v-select>
            </div>
            <LoadingScreen v-if="loadingResults" />
            <template v-else>
                <details class="table-results__content__list" v-for="(item, key) in listResults" :key="key" open>
                    <summary class="table-results__content__summary" :class="{ pointer: item.tiers && item.tiers.length > 0 }">
                        <div class="table-results__content__header">
                            <p class="name">{{ item.event_name ? getTranslatedText(item.event_name) : item.draw_name }}</p>
                            <p class="date">{{ renderDate(item.draw_date) }}</p>
                        </div>
                        <div class="numbers-cell-box"> 
                            <div class="numbers-cell">
                                <div class="number" v-for="(data, index) in item.results" :key="index">
                                    <p v-for="(value, i) in data" :key="i">
                                        {{ value }}
                                    </p>
                                    <b v-if="index !== item.results.length - 1">+</b>
                                </div>
                            </div>
                            <div v-if="item?.double_chance_results?.length > 0" class="numbers-cell">
                                <div class="number" v-for="(data, index) in item.double_chance_results" :key="index">
                                    <p v-for="(value, i) in data" :key="i">
                                        {{ value }}
                                    </p>
                                    <b v-if="index !== item.results.length - 1">+</b>
                                </div>
                            </div>
                        </div>
                        <div class="table-results__watch-video" v-if="(isMultiLotto && item.results && item.results.length >= 2) || (CT_GAME_SLUG.LOTTO_459 && CT_GAME_SLUG.LOTTO_459.includes(propsDataGames.name?.toLowerCase()) && item.results && item.results.length > 0)">
                            <a 
                                :href="getWatchVideoUrl(item)" 
                                target="_blank" 
                                class="watch-video-link"
                            >
                                {{ getTranslatedText('Watch Video') }}
                            </a>
                        </div>
                    </summary>
                    <table class="table-results__table-tiers" v-if="item.tiers && item.tiers.length > 0">
                        <thead>
                            <tr>
                                <th class="table-results__table-tiers__name">{{ getTranslatedText('Match Numbers') }}</th>
                                <th class="table-results__table-tiers__winners">{{ getTranslatedText('Winners') }}</th>
                                <th class="table-results__table-tiers__payouts">{{ getTranslatedText('Payout') }}</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(tier, i) in item.tiers" :key="i">
                                <td>{{ renderNameNumberN(tier.name) }}</td>
                                <td>{{ renderPrice(tier.winners) }}</td>
                                <td>{{ renderPrice(tier.prize) }}</td>
                            </tr>
                        </tbody>
                    </table>
                </details>
                <div class="empty" v-if="listResults.length === 0">{{ getTranslatedText('No Result') }}</div>
            </template>
        </div>
        <div class="table-results__button" v-if="isMultiLotto">
            <ButtonCommon type="default" :isNoHover="true" value="Previous Date" :isLoading="isLoadingPrevious" nameFunction="onClickPreviousDate" />
            <ButtonCommon type="error" :isNoHover="true" value="Next Date" :isLoading="isLoadingNext" :isDisable="isDisableNext" nameFunction="onClickNextDate" />
        </div>
    </div>
</template>

<script>
import languageMixins from '@/mixins/language/language-mixins'
import themeMixins from '@/mixins/pathAssets/path-assets-mixins'
import DatePicker from '@/components/common/datepicker/index.vue'
import ResultsService from '@/services/results.service'
import EventBus from '@/utils/EventBus'
import ButtonCommon from '@/components/common/button/index.vue'
import LoadingScreen from '@/components/common/loading/index.vue'

import { convertDate, formatDate, formatPrice, getAllSaturdays, getLocalDateString } from '@/utils/utils'
import { CT_GAME_SLUG } from '@/constants/game'

const RESULTS_POLL_INTERVAL_MS = 15000
const RESULTS_POLL_MAX_DURATION_MS = 2 * 60 * 60 * 1000

export default {
    mixins: [languageMixins, themeMixins],
    components: { DatePicker, ButtonCommon, LoadingScreen },
    props: {
        isMultiLotto: {
            type: Boolean,
            default: false,
        },
        propsDataGames: {
            type: Object,
            default: () => {},
        },
    },
    data() {
        return {
            date: getLocalDateString(),
            listResults: [],
            loadingResults: false,
            isLoadingPrevious: false,
            isLoadingNext: false,
            isDisableNext: false,
            selectedDatePariLotto: '',
            dataSelectPariLotto: [],
            CT_GAME_SLUG,
            resultsPollTimer: null,
            resultsPollStartedAt: null,
        }
    },
    watch: {
        isMultiLotto() {
            this.stopResultsPolling()
            this.date = getLocalDateString()
            this.listResults = []
            this.loadingResults = false
            this.isLoadingPrevious = false
            this.isLoadingNext = false
            this.isDisableNext = false
            this.selectedDatePariLotto = ''
            this.dataSelectPariLotto = []
            this.isMultiLotto ? this.fetchDataResults(this.date) : this.onGetlistSaturday()
        },
        selectedDatePariLotto() {
            this.loadingResults = true
            this.fetchDataResultsPariLoto(this.selectedDatePariLotto)
        },
    },
    created() {
        const step = this.$store.state.stepCart

        if (this.isMultiLotto) {
            this.fetchDataResults(this.date)
        } else if (step !== 1) {
            this.syncDatePicker(this.date)
            this.fetchDataResultsPariLoto(this.date)
        } else {
            this.onGetlistSaturday()
        }

        EventBus.$on('date', (value) => {
            this.date = value
            const step = this.$store.state.stepCart
            step !== 1 ? this.fetchDataResultsPariLoto(value) : this.fetchDataResults(this.date)
        })
        EventBus.$on('onClickPreviousDate', () => {
            this.handlePreviousDate()
        })
        EventBus.$on('onClickNextDate', () => {
            this.handleNextDate()
        })
    },
    destroyed() {
        this.stopResultsPolling()
        EventBus.$off('date', () => {})
        EventBus.$off('onClickPreviousDate', () => {})
        EventBus.$off('onClickNextDate', () => {})
    },
    methods: {
        syncDatePicker(date) {
            EventBus.$emit('setDate', date)
        },

        normalizeGameLabel(value) {
            return (value || '').toLowerCase().replace(/[\s/_-]+/g, '')
        },

        itemBelongsToStep(item, step) {
            const labels = [item.game_slug, item.game, item.draw_name]
                .filter(Boolean)
                .map((value) => this.normalizeGameLabel(value))

            const slugsByStep = {
                2: CT_GAME_SLUG.LOTTO_645,
                3: CT_GAME_SLUG.LOTTO_459,
                4: CT_GAME_SLUG.LOTTO_545,
            }
            const allowedSlugs = slugsByStep[step] || []
            const activeSlug = this.normalizeGameLabel(this.propsDataGames.name)

            if (allowedSlugs.some((slug) => activeSlug.includes(this.normalizeGameLabel(slug)))) {
                const slugTokens = allowedSlugs.map((slug) => this.normalizeGameLabel(slug))
                if (labels.some((label) => slugTokens.some((token) => label.includes(token) || token.includes(label)))) {
                    return true
                }
            }

            if (step === 3) {
                return labels.some((label) => label.includes('4') && label.includes('59'))
            }
            if (step === 2) {
                return labels.some((label) => label.includes('6') && label.includes('45'))
            }
            if (step === 4) {
                return labels.some((label) => label.includes('5') && label.includes('45') && !(label.includes('4') && label.includes('59')))
            }

            return false
        },

        filterPariMutuelResults(listResults, step) {
            if (step === 1) {
                return listResults
            }

            return listResults.filter((item) => this.itemBelongsToStep(item, step))
        },

        shouldPollForResults(date) {
            return !this.isMultiLotto && date === getLocalDateString()
        },

        startResultsPolling(date) {
            this.stopResultsPolling()

            if (!this.shouldPollForResults(date)) {
                return
            }

            this.resultsPollStartedAt = Date.now()
            this.resultsPollTimer = setInterval(() => {
                if (Date.now() - this.resultsPollStartedAt > RESULTS_POLL_MAX_DURATION_MS) {
                    this.stopResultsPolling()
                    return
                }

                this.fetchDataResultsPariLoto(date, { silent: true })
            }, RESULTS_POLL_INTERVAL_MS)
        },

        stopResultsPolling() {
            if (this.resultsPollTimer) {
                clearInterval(this.resultsPollTimer)
                this.resultsPollTimer = null
            }
            this.resultsPollStartedAt = null
        },

        manageResultsPolling(date, hasResults) {
            if (hasResults || !this.shouldPollForResults(date)) {
                this.stopResultsPolling()
                return
            }

            this.startResultsPolling(date)
        },

        async fetchDataResultsPariLoto(date, options = {}) {
            const { silent = false } = options

            if (!date) {
                date = getLocalDateString()
                this.date = date
                this.syncDatePicker(date)
            }

            try {
                if (!silent) {
                    this.loadingResults = true
                }

                const resp = await ResultsService.listResults(date, 'pari-mutuel-lotto')
                if (resp.code === 200) {
                    const step = this.$store.state.stepCart
                    const listResults = this.filterPariMutuelResults(resp.data, step)
                    this.listResults = listResults
                    this.manageResultsPolling(date, listResults.length > 0)
                }
            } catch (error) {
                console.log(error)
            } finally {
                if (!silent) {
                    this.loadingResults = false
                }
            }
        },

        async fetchDataResults(date) {
            this.loadingResults = true
            if (date === getLocalDateString()) {
                this.isDisableNext = true
            } else {
                this.isDisableNext = false
            }
            try {
                const resp = await ResultsService.listResults(date, 'multi-lotto')
                if (resp.code === 200) {
                    this.listResults = resp.data
                    this.manageResultsPolling(date, resp.data.length > 0)
                }
                this.isLoadingPrevious = false
                this.isLoadingNext = false
            } catch (error) {
                console.log(error)
            } finally {
                this.loadingResults = false
            }
        },

        onGetlistSaturday() {
            let dataSelectPariLotto = getAllSaturdays()
            let dateDefault = dataSelectPariLotto[0]
            this.selectedDatePariLotto = dateDefault
            this.dataSelectPariLotto = dataSelectPariLotto
        },

        shiftDate(days) {
            const day = new Date(`${this.date}T12:00:00`)
            day.setDate(day.getDate() + days)
            return getLocalDateString(day)
        },

        handlePreviousDate() {
            this.isLoadingPrevious = true
            this.date = this.shiftDate(-1)
            this.fetchDataResults(this.date)
        },

        handleNextDate() {
            this.isLoadingNext = true
            this.date = this.shiftDate(1)
            this.fetchDataResults(this.date)
        },

        formatDate(date) {
            if (!date) return null
            const [year, month, day] = date.split('-')
            return `${day}/${month}/${year}`
        },

        renderDate(date) {
            const dateFormat = formatDate(convertDate(date))
            let valueDate = `${dateFormat.hour24h}H${dateFormat.minutes}`
            return valueDate
        },

        renderPrice(price) {
            return formatPrice(price, 2)
        },

        renderNameNumberN(name) {
            return name.slice(-1)
        },

        renderHeaderTitle() {
            let title = 'Results - Change to '
            if (this.propsDataGames.name === 'lotto-6-45') {
                title += '6/45'
            } else if (CT_GAME_SLUG.LOTTO_459.includes(this.propsDataGames.name?.toLowerCase())) {
                title += '4/59'
            } else if (this.propsDataGames.name === 'lotto-5-45') {
                title += '5/45'
            } else {
                title += '5/90'
            }

            return this.getTranslatedText(title)
        },

        getWatchVideoUrl(item) {
            // Check if it's 4/59 game
            const is459 = CT_GAME_SLUG.LOTTO_459.includes(this.propsDataGames.name?.toLowerCase())
            
            // Format date
            const drawDate = new Date(item.draw_date)
            const formattedDate = drawDate.toLocaleDateString('fr-FR', {
                weekday: 'long',
                year: 'numeric',
                month: 'long',
                day: 'numeric'
            }).toUpperCase()

            if (is459) {
                // For 4/59: just show 4 numbers
                const numbers = item.results && item.results[0] ? item.results[0] : []
                
                const params = {
                    results: encodeURIComponent(JSON.stringify({
                        numbers
                    })),
                    date: formattedDate
                }

                const baseUrl = window.location.origin
                const queryString = Object.keys(params)
                    .map(key => `${key}=${params[key]}`)
                    .join('&')
                
                return `${baseUrl}/draw-animation-459.html?${queryString}`
            } else {
                // For 5/90: Parse results for 5/90 format
                // results: [[5 main numbers], [2 bonus numbers]]
                // double_chance_results: [[5 main numbers], [2 bonus numbers]] (if available)
                
                const firstFive = item.results && item.results[0] ? item.results[0] : []
                const bonusTwo = item.results && item.results[1] ? item.results[1] : []
                
                // For last 5 + 2 joker, use double_chance_results if available, otherwise use results again
                let lastFive = []
                let jokerTwo = []
                
                if (item.double_chance_results && item.double_chance_results.length >= 2) {
                    lastFive = item.double_chance_results[0] || []
                    jokerTwo = item.double_chance_results[1] || []
                } else if (item.results && item.results.length >= 3) {
                    // If there's a third array in results
                    lastFive = item.results[2] || []
                    jokerTwo = item.results[3] || []
                } else {
                    // Fallback: use same as first set if no second set available
                    lastFive = firstFive
                    jokerTwo = bonusTwo
                }

                // Build query params
                const params = {
                    results: encodeURIComponent(JSON.stringify({
                        firstFive,
                        bonusTwo,
                        lastFive,
                        jokerTwo
                    })),
                    eventName: item.event_name || 'Le Big',
                    date: formattedDate
                }

                // Build URL to the HTML file in public folder
                const baseUrl = window.location.origin
                const queryString = Object.keys(params)
                    .map(key => `${key}=${params[key]}`)
                    .join('&')
                
                return `${baseUrl}/draw-animation.html?${queryString}`
            }
        },
    },
}
</script>
<style lang="scss">
@import '~ThemePath/scss/results/_table-results.scss';
</style>
